import { Injectable } from '@angular/core';
import { HttpHeaders } from '@freelancer/freelancer-http';
import { Interface } from '@freelancer/types';
import * as Rx from 'rxjs';
import { ErrorTracking } from '../error-tracking.service';

@Injectable()
export class ErrorTrackingTesting implements Interface<ErrorTracking> {
  setupSentrySDK(): void {
    // no-op
  }

  captureMessage(msg: string, extras?: unknown): void {
    // Do nothing
  }

  captureException(error: Error, extras?: unknown): void {
    // Do nothing
  }

  getTracingHeaders(): Rx.Observable<HttpHeaders> {
    return Rx.of(new HttpHeaders());
  }
}
